export const register = {
  field: {
    currency: 'Currency',
    email: 'E-mail address',
    phone_number: 'Phone number',
    terms: 'Terms and Conditions'
  },
  button: {
    check_code: 'Confirm',
    continue: 'continue',
    create_account: 'Create account',
    new_code: 'New code',
    recovery_password: 'Forgot your password?\n',
    register: 'Register',
    use_different_number: 'Use a different phone number',
    change_number: 'Change number',
    resend: 'Resend'
  },
  error: {
    1001: 'SMS code request per minute limit exceeded, please try again later',
    1002: 'SMS code request per hour limit exceeded, please try again later',
    1003: 'Number verification request not found',
    1004: 'Attempt limit exceeded, request a new verification code',
    1005: 'Invalid confirmation code',
    something_went_wrong: 'Something went wrong',
    email: 'The Email address has already been taken.',
    phone: 'The Phone has already been taken.'
  },
  modal: {
    registration_successfully: 'Registration successful',
    registration_successfully_text: `<span style="display: block">Thank you for registration.</span>
      <span>Login data sent to your email address.</span>`
  },
  confirm: {
    title: 'Confirmation',
    text: 'We have sent the confirmation code to',
    sending_sms: 'Sending SMS',
    change_number_text: 'Are you sure you want to resend the confirmation code to',
    acc_configured: `Setting up account. <br> It will take less than a minute`
  },
  events: {
    welcome: `Thank you for the registration! <br>Account credentials were sent to your email. <br> You also have 5 welcome dollars on your account.`,
    fail:
      'An error occurred during registration. Additional information has been sent to the specified email.',
    timeout:
      'An error occurred during registration. Please contact our support team. We will help you solve your problem.'
  },
  change_not_possible: 'Change it later will not be possible',
  choose_currency:
    'Choose the currency in which you will be most comfortable to make calculations, receive statistics and financial reports.',
  email_address: 'E-Mail Address',
  i_agree: 'I agree to the ',
  log_in: 'LOG IN',
  phone_verified: 'Phone number verified',
  phone_verify_code: 'SMS verification code',
  terms_and_conditions: 'Terms and Conditions',
  have_acc: 'Already have an account?',
  private_registration_title: 'Private registration',
  private_registration_text: 'Write to us to register an account',
  private_registration_button: 'Contact us'
};
